import { mapGetters } from 'vuex';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
var bgColor = ['#0E6959', '#ABE629', '#38003E', '#EBB600', '#005EA9', '#741B47', '#DB2165'];
var walkscorebgColor = ['#0E6959', '#ABE629', '#38003E', '#EBB600', '#005EA9', '#741B47', '#DB2165'];

export default {
    name: 'mvtLocalHighlightScore',
    inject: ['$eventBus'],
    props: {
        localHighlightScore: {
            type: Array,
            default() {
                return [];
            },
        },
        xsOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            panelIndex: 0,
            activeInfo: null,
        };
    },
    components: {
        mvtChart,
    },
    methods: {
        updateActiveInfo(i, j) {
            if (i >= this.getData.length || j >= this.getData[i].tags.length) {
                return;
            }
            this.panelIndex = i;
            var tagInfo = this.getData[i].tags[j];
            var activeInfo = {};

            activeInfo.field = tagInfo.field;

            if (tagInfo.img) {
                activeInfo.img = `${this.glb.cdnUrl}images/desktop/dpp/${tagInfo.img}`;
            } else if (tagInfo.data) {
                var color = bgColor[j];
                var data = {
                    labels: tagInfo.label,
                    datasets: [
                        {
                            label: tagInfo.name,
                            data: tagInfo.data,
                            backgroundColor: this.getBarColor(tagInfo, color),
                        },
                    ],
                };
                activeInfo.chartData = {
                    type: 'bar',
                    data: data,
                    options: {
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        display: false,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                    },
                };
                switch (tagInfo.type) {
                    case 'fprice':
                    case 'fquality':
                        activeInfo.chartData.options.tooltips = {
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    return tooltipItem.yLabel + '%';
                                },
                            },
                        };
                        activeInfo.chartData.options.scales.yAxes = [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 25,
                                    callback: function (value, index, values) {
                                        return value + '%';
                                    },
                                },
                                stacked: true,
                            },
                        ];
                        break;
                    case 'fdiversity':
                        activeInfo.chartData.options.scales.yAxes = [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 5,
                                    callback: function (value, index, values) {
                                        return (value * 1).toFixed(0);
                                    },
                                },
                            },
                        ];
                        break;
                }
            }
            activeInfo.tags = this.getData[i].tags.map(function (e) {
                return e.name;
            });
            activeInfo.title = this.getData[i].type == 'walkscore' ? this.getData[i].title : this.getData[i].title + ' Score';
            switch (this.getData[i].type) {
                case 'food':
                    activeInfo.desc = this.molang('dpp.propertyLocalScore.foodDesc');
                    break;
                case 'kid':
                    activeInfo.desc = this.molang('dpp.propertyLocalScore.kidDesc');
                    break;
                case 'dog':
                    activeInfo.desc = this.molang('dpp.propertyLocalScore.dogDesc');
                    break;
                case 'walkscore': {
                    if (this.getData[i].value < 30) {
                        activeInfo.desc = this.molang('dpp.propertyLocalScore.walkrateLowDesc');
                    } else if (this.getData[i].value < 61) {
                        activeInfo.desc = this.molang('dpp.propertyLocalScore.walkrateAvgDesc');
                    } else if (this.getData[i].value < 85) {
                        activeInfo.desc = this.molang('dpp.propertyLocalScore.walkrateGoodDesc');
                    } else {
                        activeInfo.desc = this.molang('dpp.propertyLocalScore.walkrateBestDesc');
                    }
                    break;
                }
            }

            this.activeInfo = activeInfo;
        },
        getBarColor(tagInfo, color) {
            let colors = [];
            switch (tagInfo.type) {
                case 'wscore':
                    colors = tagInfo.data.map((el, i) => walkscorebgColor[i]);
                    break;
                default:
                    colors = tagInfo.data.map(function () {
                        return color;
                    });
            }
            return colors;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        getData() {
            const array = [];
            if (this.localHighlightScore && this.localHighlightScore.length) {
                for (let i = 0; i < this.localHighlightScore.length; i++) {
                    let scores = this.localHighlightScore[i];
                    if (scores.tags && scores.tags.length) {
                        const labels = [];
                        const data = [];
                        const backgroundColor = [];
                        scores.tags.forEach(function (e, i) {
                            labels.push(e.name);
                            data.push(e.value);
                            backgroundColor.push(bgColor[i]);
                        });
                        if (scores.value < 100) {
                            data.push(100 - Math.round(scores.value));
                            labels.push(' ');
                            backgroundColor.push('#f5f6f8');
                        }
                        const chartData = {
                            type: 'doughnut',
                            data: {
                                labels,
                                datasets: [
                                    {
                                        data,
                                        backgroundColor,
                                        borderWidth: 0,
                                    },
                                ],
                            },
                            options: {
                                cutoutPercentage: 70,
                                legend: {
                                    display: false,
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                elements: {
                                    center: {
                                        text: scores.value,
                                        color: '#666',
                                        maxFontSize: 20,
                                    },
                                },
                                tooltips: {
                                    enabled: false,
                                    custom: function(tooltipModel) {
                                        var tooltipEl = document.getElementById('chartjs-tooltip');
                                        if (!tooltipEl) {
                                            tooltipEl = document.createElement('div');
                                            tooltipEl.id = 'chartjs-tooltip';
                                            document.body.appendChild(tooltipEl);
                                        }
                                        if (tooltipModel.opacity === 0) {
                                            tooltipEl.style.opacity = 0;
                                            return;
                                        }
                                        tooltipEl.classList.add('localhighlight-chart');
                                        if (tooltipModel.body) {
                                            var innerHtml = '';
                                            var bodyLines = tooltipModel.body.map((bodyItem)=>{return bodyItem.lines});
                                            if (tooltipModel.labelColors && tooltipModel.labelColors.length) {
                                                innerHtml += `<span style="border-color:${tooltipModel.labelColors[0].borderColor};background-color:${tooltipModel.labelColors[0].backgroundColor}"></span>`;
                                            }
                                            bodyLines.forEach((body) => {innerHtml += body;});
                                            tooltipEl.innerHTML = innerHtml;
                                        }
                                        var position = this._chart.canvas.getBoundingClientRect();
                                        tooltipEl.style.opacity = 1;
                                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                                    }
                                }
                            },
                        };
                        array.push({
                            tags: scores.tags,
                            type: scores.type,
                            value: scores.value,
                            title: scores.title,
                            chartData,
                        });
                    }
                }
            }
            return array;
        },
        showTabs() {
            return this.activeInfo.tags && this.activeInfo.tags.length > 1;
        },
    },
};
